import { DEFAULT_STATE } from '../constants'
import { searchPageStore } from '../index'

/**
 * Sets the file types array
 * @param {string[]} fileTypes - Array of file type strings
 */
export const setFileTypes = (fileTypes) => {
  searchPageStore.setState(fileTypes.length > 0 ? { fileTypes } : { fileTypes, nativeOnly: false })
}

/**
 * Adds a file type to the array
 * @param {string} fileType - File type to add
 */
export const addFileType = (fileType) => {
  const state = searchPageStore.getState()
  const currentFileTypes = state.fileTypes || []

  if (!currentFileTypes.includes(fileType)) {
    searchPageStore.setState({ fileTypes: [...currentFileTypes, fileType] })
  }
}

/**
 * Removes a file type from the array
 * @param {string} fileType - File type to remove
 */
export const removeFileType = (fileType) => {
  const state = searchPageStore.getState()
  const currentFileTypes = state.fileTypes || []

  const fileTypes = currentFileTypes.filter((type) => type !== fileType)

  searchPageStore.setState(fileTypes.length > 0 ? { fileTypes } : { fileTypes, nativeOnly: false })
}

/**
 * Clears all file types filter
 */
export const clearFileTypes = () => {
  searchPageStore.setState({
    fileTypes: DEFAULT_STATE.fileTypes,
    nativeOnly: DEFAULT_STATE.nativeOnly,
  })
}

/**
 * Narrows the selected file types to the ones marked as the original project file
 * @param {boolean} nativeOnly
 */
export const setNativeOnly = (nativeOnly) => {
  searchPageStore.setState({ nativeOnly })
}
